/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getMeasuredRolloutOverrides';

export type GetMeasuredRolloutPathParams = NonNullable<operations['getMeasuredRollout']['parameters']['path']>;

export type GetMeasuredRolloutQueryParams = NonNullable<operations['getMeasuredRollout']['parameters']['query']>;

export interface Input extends GetMeasuredRolloutPathParams {
  apiVersion?: string;
  query?: GetMeasuredRolloutQueryParams;
}

export async function getMeasuredRollout(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/api/v2/projects/{projectKey}/flags/{flagKey}/environments/{environmentKey}/measured-rollouts/{measuredRolloutId}',
    {
      params: { path, query },
      headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
      signal,
    },
  );
}
